export const BLOCKED_FAILED_PAYMENT_MODAL = 'go4ellis/Modals/BLOCKED_FAILED_PAYMENT_MODAL';
export const WAIT_UNTIL_FAILED_PAYMENT_PROCESS = 'go4ellis/Modals/WAIT_UNTIL_FAILED_PAYMENT_PROCESS';

const blockedForFailedPaymentReducer = state => ({
  ...state,
  blockedForFailedPayment: !state.blockedForFailedPayment
})

const waitUntilFailedPaymentProcessReducer = state => ({
  ...state,
  waitUntilFailedPaymentProcess: !state.waitUntilFailedPaymentProcess
})

export const triggerBlockedFailedPaymentModal = () => ({
  type: BLOCKED_FAILED_PAYMENT_MODAL,
})

export const triggerWaitUntilFailedPaymentProcessModal = () => ({
  type: WAIT_UNTIL_FAILED_PAYMENT_PROCESS,
})

const DEFAULT_STATE = {
  blockedForFailedPayment: false,
  waitUntilFailedPaymentProcess: false,
};

export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case BLOCKED_FAILED_PAYMENT_MODAL:
      return blockedForFailedPaymentReducer(state);
    case WAIT_UNTIL_FAILED_PAYMENT_PROCESS:
      return waitUntilFailedPaymentProcessReducer(state);
    default: return state;
  }
}